// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"9eaed259","287":"dc980b7d","649":"2e93a9a3","787":"cda612ba","794":"275509de","950":"668187a5","975":"e4eaaeea"}[chunkId] + ".chunk.js";
};